import { IGetAllResourceBookingsSingleResponse } from 'types/api/operationsBookingApi.interface'

export const resourceTypes = [
  { label: 'Worker', value: 1 },
  { label: 'Machine', value: 2 },
]

export const resourceTypeOptions = [
  { label: 'Worker', value: 1 },
  { label: 'Machine', value: 2 },
]

export const holderTypes = [
  { label: 'Plan', value: 1 },
  { label: 'Phase', value: 2 },
  { label: 'Cycle', value: 3 },
  { label: 'Workflow', value: 4 },
  { label: 'Shift Program', value: 5 },
  { label: 'Task', value: 6 },
  { label: 'Manual', value: 7 },
]

export const holderTypeOptions = [
  { label: 'Plan', value: 1 },
  { label: 'Shift Program', value: 5 },
]

export const bookingPriorities = [
  { label: 'Low', value: 1 },
  { label: 'Normal', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
]

export const bookingStatuses = [
  { label: 'Active', value: 1, color: '#24D07B' },
  { label: 'Released', value: 0, color: '#8A8A8A' },
]

export const getResourceLabel = (item: IGetAllResourceBookingsSingleResponse) => {
  if (item.resourceType === 1) {
    return item.resourceWorker
      ? `${item.resourceWorker.firstName} ${item.resourceWorker.lastName}`
      : '-'
  }
  return item.resourceMachine?.name || '-'
}

export const getHolderLabel = (item: IGetAllResourceBookingsSingleResponse) => {
  if (item.holderType === 1) return item.holderPlan?.name || '-'
  if (item.holderType === 5) return item.holderShiftProgram?.name || '-'
  return '-'
}
